import { AbstractControl } from '@angular/forms';

function charToValue(char: string): number {
  const code = char.charCodeAt(0);
  if (code >= 65 && code <= 90) return code - 48;
  return Number(char);
}

function computeCheckDigit(values: number[], weights: number[]): number {
  let sum = 0;
  for (let i = 0; i < values.length; i++) {
    sum += values[i] * weights[i];
  }
  const remainder = sum % 11;
  const digit = 11 - remainder;
  return digit > 9 ? 0 : digit;
}

function validate(cnpj: string) {
  const normalized = String(cnpj)
    .replace(/[./-]/g, '')
    .toUpperCase();

  if (!/^[A-Z0-9]{14}$/.test(normalized)) return false;

  if (!/^\d{2}$/.test(normalized.slice(12))) return false;

  const chars = normalized.split('');
  const values = chars.map(charToValue);

  const base = new Set(normalized.slice(0, 12).split(''));
  if (base.size === 1) return false;

  const checkDigits = values.slice(12);

  const firstDigit = computeCheckDigit(values.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  if (firstDigit !== checkDigits[0]) return false;

  const secondDigit = computeCheckDigit(values.slice(0, 13), [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  return secondDigit === checkDigits[1];
}

export const cnpj = (control: AbstractControl) => {
  const { value } = control;
  if (!value || validate(value)) return null;

  return { cnpj: { message: 'CNPJ inválido' } };
};
